<template>
    <div class="mail-page">
        <h5>Correspondencia</h5>
        <b-row>
            <b-col cols="12" md="auto">
                <b-btn
                    variant="primary"
                    v-if="userCan('handle-mails')"
                    class="btn-block-xs-only"
                    @click="$bus.$emit('receive-mail-form-window.open')"
                    ><i class="fa fa-plus"></i> Recibir Correspondencia</b-btn
                >
            </b-col>
            <b-col cols="12" md="auto">
                <b-btn
                    variant="primary"
                    v-if="userCan('handle-mails')"
                    class="btn-block-xs-only"
                    @click="$router.push({ name: 'mailDistribution' })"
                    ><i class="fa fa-plus"></i> Recibir Correspondencia
                    masivamente</b-btn
                >
            </b-col>
        </b-row>

        <!-- Selectores de cliente y puesto para usuarios que no seleccionan cliente al ingresar -->
        <b-row class="my-2" v-if="requireAccessPoint">
            <b-col cols="12" class="mt-2" v-if="!user.profile.client_side">
                <app-autocomplete
                    :items="clients"
                    label="Cliente"
                    @input="onClientSelected"
                    v-model="selectedClient"
                ></app-autocomplete>
            </b-col>
            <b-col cols="12" class="mt-2">
                <app-autocomplete
                    :items="accessPoints"
                    label="Puesto"
                    @input="onAccessPointChange"
                    v-model="selectedAccessPoint"
                    :disabled="inProgress"
                ></app-autocomplete>
            </b-col>
        </b-row>
        <b-tabs>
            <b-tab title="Por Entregar" active>
                <b-card>
                    <app-deliver-form ref="deliver-form" />
                </b-card>
            </b-tab>
            <b-tab title="Entregada">
                <b-card>
                    <app-delivered-mail ref="delivered-form" />
                </b-card>
            </b-tab>
        </b-tabs>

        <app-pop-up
            id="receive-mail-form-window"
            title="Recibir correspondencia"
            :onClose="cleanForm"
        >
            <div class="receive-mail-form-slot" slot="body">
                <app-receive-form :onSave="onSave" />
            </div>
            <div class="receive-mail-form-buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('receive-mail.save')"
                >
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import ReceiveForm from './ReceiveForm/ReceiveForm.vue'
import DeliverForm from './DeliverForm/DeliverForm.vue'
import PopUp from '../../../UI/Controls/PopUp/PopUp.vue'
import { mapGetters, mapMutations } from 'vuex'
import DeliveredMail from './DeliveredMail/DeliveredMail.vue'

export default {
    components: {
        appReceiveForm: ReceiveForm,
        appDeliverForm: DeliverForm,
        appPopUp: PopUp,
        appDeliveredMail: DeliveredMail,
    },
    data: () => ({
        accessPoints: [],
        selectedClient: null,
        selectedAccessPoint: null,
        clients: [],
    }),
    watch: {
        accessPoints(val) {
            if (!val) return

            if (this.accessPoint) {
                this.selectedAccessPoint = this.accessPoint
            }
        },
    },
    computed: {
        requireAccessPoint() {
            return ['supervisor', 'cliente-admin'].includes(
                this.user.profile.slug
            )
        },
    },
    methods: {
        ...mapMutations({
            setClient: 'client',
            setAccessPoint: 'accessPoint',
        }),
        cleanForm() {
            this.$bus.$emit('receive-form.clean')
        },
        onSave() {
            this.$bus.$emit('receive-mail-form-window.close')
            this.$bus.$emit('mail-list.refresh')
        },
        async onClientSelected(client) {
            this.setClient(client)
            this.$refs['deliver-form'].clear()
            this.$refs['delivered-form'].clear()
            this.selectedAccessPoint = null
            this.setAccessPoint(this.selectedAccessPoint)
            this.accessPoints = []
            this.loadAccessPoints()
        },
        async loadAccessPoints() {
            const { data } = await repo.get(
                `structures/access-points/client/${this.client.id}`
            )
            this.accessPoints = data
        },
        onAccessPointChange(ap) {
            this.setAccessPoint(ap)
        },
        async loadClients() {
            const { data } = await repo.get('clients/list')
            this.clients = data
        },
    },
    mounted() {
        // this.load('clients')
        this.loadClients()

        if (!!this.client) {
            this.selectedClient = this.client
            this.loadAccessPoints()
        }
    },
}
</script>
